import React from 'react';
import { Col, Row } from 'reactstrap';
import { Image, H4, P, H6 } from '../../../AbstractElements';

import Avatar from '../../../assets/images/user/1.jpg';
import { AvatarEmail, AvatarName, AvatarPhone, ProjectDescription, ProjectDescriptionPera } from '../../../Constant';
const ProfileHeader = () => {
  return (
    <Row className='invo-profile'>
      <Col xl='4'>
        <div className='invo-profile-left'>
          <div className='d-flex'>
            <div className='d-flex-left'>
              <Image className='d-flex-object rounded-circle img-60' src={Avatar} alt='' />
            </div>
            <div className='flex-grow-1 ms-3'>
              <H4 className='d-flex-heading f-w-600'>{AvatarName}</H4>
              <P>
                {AvatarEmail}
                <span className='digits'>{AvatarPhone}</span>
              </P>
            </div>
          </div>
        </div>
      </Col>
      <Col xl='8'>
        <div className='invo-profile-right'>
          <div id='project'>
            <H6>{ProjectDescription}</H6>
            <P>{ProjectDescriptionPera}</P>
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default ProfileHeader;
